// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"793a2d3b","732":"ca650d77","815":"1aa5bb8e","816":"a954438e","991":"d2136363"}[chunkId] + ".css";
};